export default __webpack_public_path__ + "static/media/setting.388ced32.png";